import { Group } from "@mantine/core"
import { AgencyOperationsAdminVenueAreaTabs } from "src/components/agency/operations/administrator/venues/areas/AgencyOperationsAdminVenueAreaTabs"
import { EditAgencyOperationsAdminVenueAreaAction } from "src/components/agency/operations/administrator/venues/areas/AgencyOperationsAdminVenueAreaActions"
import { useAppState } from "src/state"
import { DrawerPageLayout } from "src/components/ui/DrawerPageLayout"
import { DrawerPageHeader } from "src/components/ui/DrawerPageHeader"
import { AgencyOperationsAdminVenueAreaView } from "src/components/agency/operations/administrator/venues/areas/AgencyOperationsAdminVenueAreaView"

export const AgencyOperationsAdminVenueAreaOverlay = () => {

    const { currentItem } = useAppState(state => state.areas)

    return (
        <DrawerPageLayout
            header={
                <DrawerPageHeader
                    title={`${currentItem?.name}`}
                    renderAction={
                        <Group gap="sm">
                            <EditAgencyOperationsAdminVenueAreaAction />
                        </Group>
                    }
                />
            }
        >
            <AgencyOperationsAdminVenueAreaTabs overlay/>
            <AgencyOperationsAdminVenueAreaView/>
        </DrawerPageLayout>
    )

}